/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_Expires_AtInputs */

const en_admin_credits_expires_at = /** @type {(inputs: Admin_Credits_Expires_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires At`)
};

const zh_admin_credits_expires_at = /** @type {(inputs: Admin_Credits_Expires_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过期时间`)
};

/**
* | output |
* | --- |
* | "Expires At" |
*
* @param {Admin_Credits_Expires_AtInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_credits_expires_at = /** @type {((inputs?: Admin_Credits_Expires_AtInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_Expires_AtInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_credits_expires_at(inputs)
	return zh_admin_credits_expires_at(inputs)
});
export { admin_credits_expires_at as "admin.credits.expires_at" }